import * as types from 'legacy/src/constants/types';

const initialState = {
  date: '',
};

const skillSummary = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SKILL_SUMMARY_UPDATED_AT:
      return {
        ...state,
        date: action.payload,
      };
    default:
      return state;
  }
};

export default skillSummary;
